//Toggle password visibility
document.addEventListener('DOMContentLoaded', function () {
    if (window.pwVisibilityFired) {
        return;
    }
    // let customerPasswordArr = document.getElementById("CustomerPassword");
    window.pwVisibilityFired = true;
    let passwordWrappers = document.getElementsByClassName('show-hide-password_wrapper');

    function passwordVisibility(e) {
        if (!e) {
            return;
        }
        if (e.type === "password") {
            e.type = "text";
        } else {
            e.type = "password";
        }
    }

    for (let passwordWrapper of passwordWrappers) {
        passwordWrapper.addEventListener('click', function () {
            let toggleLink = passwordWrapper.closest('form').querySelector('.show-hide-password_btn');

            passwordVisibility(passwordWrapper.closest('form').querySelector('#CustomerPassword'));

            passwordVisibility(passwordWrapper.closest('form').querySelector('#RegisterForm-password'));

            passwordWrapper.closest('form').querySelector('.inactive').classList.toggle("hide");

            passwordWrapper.closest('form').querySelector('.active').classList.toggle("hide");

            if (toggleLink.innerHTML === 'show') {
                toggleLink.innerHTML = 'hide';
            } else {
                toggleLink.innerHTML = 'show';
            }
        })
    }
});